<template>
  <v-dialog v-model="show" width="500px"
    >-->
    <v-card>
      <v-card-title>
        <v-col cols="12">
          <label>Role</label>
          <v-autocomplete
            v-model="roleData"
            :items="roleList"
            chips
            clearable
            filled
            label="choose roles"
            item-text="role_name"
            color="blue-grey lighten-2"
            item-value="id"
            multiple
          >
            <template v-slot:selection="data">
              <v-chip
                v-bind="data.attrs"
                :input-value="data.selected"
                @click="data.select"
              >
                {{ data.item.role_name }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>
      </v-card-title>
      <v-card-actions>
        <v-btn rounded color="info" @click="addRole">Insert</v-btn>
        <v-btn rounded color="secondary" @click="clearRole">Cancel</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions} from "vuex";
import DEFAULT_CONSTANTS from "@/Utilites/constants";
export default {
  name: "ProjectRoleAdd",
  props: ["roleAdd", "roleList"],
  data() {
    return {
      roleData: [],
    };
  },
  computed: {
    show: {
      get() {
        return this.roleAdd;
      },
      set(show) {
        this.$emit("update-add-role-modal", show);
      },
    },
  },
  methods: {
    ...mapActions([
      "showLoadingProcess",
      "closeLoading",
      "CreateProjectRole",
      "showSnackBar",
      "closeSnackBar",
    ]),
    async addRole() {
      await this.showLoadingProcess();
      try {
        await this.CreateProjectRole({
          project_id: this.$route.query.project_id,
          role_id: this.roleData,
        });
        await this.closeLoading();
        this.clearRole();
        await this.showSnackBar({
          text: "Roles has been added to Project",
          color: DEFAULT_CONSTANTS.success,
        });
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      } catch (err) {
        this.clearRole();
        await this.closeLoading();
        await this.showSnackBar({
          text: JSON.stringify(err),
          color: DEFAULT_CONSTANTS.error,
        });
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      }
    },
    clearRole() {
      this.show = false;
      this.roleData = [];
    },
  },
};
</script>

<style scoped></style>
